import React from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import { observable, toJS } from 'mobx'
import useCollection from './hooks/use-collection'
import CollectionContext from './contexts/CollectionContext'

function GroupBy (props) {
  const groupedCollectionRef = React.useRef(observable.array())
  const groupedCollection = groupedCollectionRef.current

  const collection = useCollection()

  const data = toJS(collection)

  const groups = data.reduce((storage, item) => {
    const group = item[props.by]

    storage[group] = storage[group] || []
    storage[group].push(item)

    return storage
  }, {})

  groupedCollection.replace(Object.keys(groups).map(key => {
    return observable.map({
      key: key,
      collection: observable.array(
        groups[key].map(e => observable.map(e))
      )
    })
  }))

  return (
    <CollectionContext.Provider value={groupedCollection}>
      {props.children}
    </CollectionContext.Provider>
  )
}

GroupBy.defaultProps = {}

GroupBy.propTypes = {
  by: PropTypes.any
}

export default observer(GroupBy)
